import { LifeRecordTroubleshootingComponent } from "./life-record-troubleshooting/life-record-troubleshooting.component";
import { AdminVisitsComponent } from "./admin-visits/admin-visits.component";
import { ManagerGuard } from "./manager-guard.service";
import { EngineReportAmraComponent } from "./engine-report-amra/engine-report-amra.component";
import { LifeRecordReportVisitComponent } from "./life-record-report-visit/life-record-report-visit.component";
import { VisitReportComponent } from "./visit-report/visit-report.component";
import { EngineReportComponent } from "./engine-report/engine-report.component";
import { ItemCheckComponent } from "./item-check/item-check.component";
import { StoreGuard } from "./services/store-guard.service";
import { AuditGuard } from "./services/audit-guard.service";
import { DoneOrdersComponent } from "./done-orders/done-orders.component";
import { VisitsComponent } from "./visits/visits.component";
import { VisitActionsComponent } from "./visit-actions/visit-actions.component";
import { AuthGuard } from "./services/auth-guard.service";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { HelpComponent } from "./help/help.component";
import { SupportComponent } from "./support/support.component";
import { LoginComponent } from "./login/login.component";
import { CatalogComponent } from "./catalog/catalog.component";
import { TroubleshootingComponent } from "./troubleshooting/troubleshooting.component";
import { SparepartsComponent } from "./spareparts/spareparts.component";
import { StockComponent } from "./stock/stock.component";
import { EngineComponent } from "./engine/engine.component";
import { PowertrainComponent } from "./powertrain/powertrain.component";
import { WorkshopComponent } from "./workshop/workshop.component";
import { AccountComponent } from "./account/account.component";
import { SettingComponent } from "./setting/setting.component";
import { AdminGuard } from "./services/admin-guard.service";
import { UsersComponent } from "./users/users.component";
import { DataGuard } from "./services/data-guard.service";
import { UnDoneOrdersComponent } from "./un-done-orders/un-done-orders.component";
import { ReminderedOrdersComponent } from "./remindered-orders/remindered-orders.component";
import { OrderPrintComponent } from "./order-print/order-print.component";
import { SparePartsInOutComponent } from "./spare-parts-in-out/spare-parts-in-out.component";
import { ItemStartComponent } from "./item-start/item-start.component";
import { ItemOutComponent } from "./item-out/item-out.component";
import { ItemInComponent } from "./item-in/item-in.component";
import { LifeRecordReportOrderComponent } from "./life-record-report-order/life-record-report-order.component";
import { ItemCheckReportComponent } from "./item-check-report/item-check-report.component";
import { ItemReportInventoryComponent } from "./item-report-inventory/item-report-inventory.component";
import { GeneralManagerGuard } from "./services/general-manager-guard.service";
import { NonCompletedOrdersReportComponent } from "./non-completed-orders-report/non-completed-orders-report.component";
import { OrdersComponent } from "./orders/orders.component";
import { StockGuard } from "./stock-guard.service";
import { CancelOrderComponent } from "./cancel-order/cancel-order.component";
import { TroubleshootingqaComponent } from "./troubleshootingqa/troubleshootingqa.component";
import { TroubleshootingqaboxComponent } from "./troubleshootingqabox/troubleshootingqabox.component";
import { QadataGuardGuard } from "./services/qadata-guard.guard";
import { QaauditGuardGuard } from "./services/qaaudit-guard.guard";
import { QavisitentryComponent } from "./qavisitentry/qavisitentry.component";
import { QavisitauditComponent } from "./qavisitaudit/qavisitaudit.component";
import { QavisitreportComponent } from "./qavisitreport/qavisitreport.component";
import { QamanagerGuardGuard } from "./services/qamanager-guard.guard";
import { QavisitreportnotacceptedComponent } from "./qavisitreportnotaccepted/qavisitreportnotaccepted.component";
import { QavisitreportnotacceptedpointsComponent } from "./qavisitreportnotacceptedpoints/qavisitreportnotacceptedpoints.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  { path: "help", component: HelpComponent },
  { path: "support", component: SupportComponent },
  { path: "login", component: LoginComponent },
  {
    path: "workshop",
    component: WorkshopComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "powercoach",
    component: PowertrainComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "engine",
    component: EngineComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "warehouse",
    component: StockComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "spareparts",
    component: SparepartsComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "item/in",
    component: ItemInComponent,
    canActivate: [StoreGuard],
  },
  {
    path: "item/out",
    component: ItemOutComponent,
    canActivate: [StoreGuard],
  },
  {
    path: "item/start",
    component: ItemStartComponent,
    canActivate: [StoreGuard],
  },
  {
    path: "item/check",
    component: ItemCheckComponent,
    canActivate: [StoreGuard],
  },
  {
    path: "troubleshooting",
    component: TroubleshootingComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "troubleshooting-qa",
    component: TroubleshootingqaComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "troubleshooting-qa-box",
    component: TroubleshootingqaboxComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "account",
    component: AccountComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "setting",
    component: SettingComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "catalog",
    component: CatalogComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "users",
    component: UsersComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "actions",
    component: VisitActionsComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "admin/visit",
    component: AdminVisitsComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "entry/visit",
    component: VisitsComponent,
    canActivate: [DataGuard],
  },
  {
    path: "admin/visit",
    component: VisitsComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "data/qavisit",
    component: QavisitentryComponent,
    canActivate: [QadataGuardGuard],
  },
  {
    path: "audit/qavisit",
    component: QavisitauditComponent,
    canActivate: [QaauditGuardGuard],
  },
  {
    path: "qa/report/completed/qavisit",
    component: QavisitreportComponent,
    canActivate: [QamanagerGuardGuard],
  },
  {
    path: "qa/report/notaccepted/qavisit",
    component: QavisitreportnotacceptedComponent,
    canActivate: [QamanagerGuardGuard],
  },
  {
    path: "qa/report/notacceptedpoints/qavisit",
    component: QavisitreportnotacceptedpointsComponent,
    canActivate: [QamanagerGuardGuard],
  },
  {
    path: "admin/report/notacceptedpoints/qavisit",
    component: QavisitreportnotacceptedpointsComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "audit/report/completed/qavisit",
    component: QavisitreportComponent,
    canActivate: [QaauditGuardGuard],
  },
  {
    path: "audit/report/notaccepted/qavisit",
    component: QavisitreportnotacceptedComponent,
    canActivate: [QaauditGuardGuard],
  },
  {
    path: "audit/report/notacceptedpoints/qavisit",
    component: QavisitreportnotacceptedpointsComponent,
    canActivate: [QaauditGuardGuard],
  },
  {
    path: "m/report/completed/qavisit",
    component: QavisitreportComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "m/report/notaccepted/qavisit",
    component: QavisitreportnotacceptedComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "m/report/notacceptedpoints/qavisit",
    component: QavisitreportnotacceptedpointsComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "admin/report/notaccepted/qavisit",
    component: QavisitreportnotacceptedComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "gm/report/notaccepted/qavisit",
    component: QavisitreportnotacceptedComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "admin/report/completed/qavisit",
    component: QavisitreportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "gm/report/completed/qavisit",
    component: QavisitreportComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "entry/order/pending",
    component: UnDoneOrdersComponent,
    canActivate: [DataGuard],
  },
  {
    path: "admin/order/pending",
    component: UnDoneOrdersComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "entry/order/reminder",
    component: ReminderedOrdersComponent,
    canActivate: [DataGuard],
  },
  {
    path: "entry/order/done",
    component: DoneOrdersComponent,
    canActivate: [DataGuard],
  },
  {
    path: "order/print",
    component: OrderPrintComponent,
    canActivate: [DataGuard],
  },
  {
    path: "audit/visit",
    component: VisitsComponent,
    canActivate: [AuditGuard],
  },
  {
    path: "audit/order/review",
    component: OrdersComponent,
    canActivate: [AuditGuard],
  },
  {
    path: "audit/order/pending",
    component: UnDoneOrdersComponent,
    canActivate: [AuditGuard],
  },
  {
    path: "audit/order/reminder",
    component: ReminderedOrdersComponent,
    canActivate: [AuditGuard],
  },
  {
    path: "audit/order/done",
    component: DoneOrdersComponent,
    canActivate: [AuditGuard],
  },

  {
    path: "report/engines",
    component: EngineReportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "order/cancel",
    component: CancelOrderComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/engines-10000",
    component: EngineReportAmraComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/item/check",
    component: ItemCheckReportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/item/stock",
    component: EngineReportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/item/get",
    component: EngineReportComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/item/inventory",
    component: ItemReportInventoryComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/life/record/visit",
    component: LifeRecordReportVisitComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/life/record/order",
    component: LifeRecordReportOrderComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/life/record/troubleshooting",
    component: LifeRecordTroubleshootingComponent,
    canActivate: [AdminGuard],
  },
  {
    path: "report/non/completed/orders",
    component: NonCompletedOrdersReportComponent,
    canActivate: [AdminGuard],
  },

  {
    path: "report/engines/m",
    component: EngineReportComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/engines-10000/m",
    component: EngineReportAmraComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/item/check/m",
    component: ItemCheckReportComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/item/stock/m",
    component: EngineReportComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/item/get/m",
    component: EngineReportComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/item/inventory/m",
    component: ItemReportInventoryComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/life/record/visit/m",
    component: LifeRecordReportVisitComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/life/record/order/m",
    component: LifeRecordReportOrderComponent,
    canActivate: [ManagerGuard],
  },
  {
    path: "report/non/completed/orders/m",
    component: NonCompletedOrdersReportComponent,
    canActivate: [ManagerGuard],
  },

  {
    path: "report/engines/gm",
    component: EngineReportComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/engines-10000/gm",
    component: EngineReportAmraComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/item/check/gm",
    component: ItemCheckReportComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/item/stock/gm",
    component: EngineReportComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/item/get/gm",
    component: EngineReportComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/item/inventory/gm",
    component: ItemReportInventoryComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/life/record/visit/gm",
    component: LifeRecordReportVisitComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/life/record/order/gm",
    component: LifeRecordReportOrderComponent,
    canActivate: [GeneralManagerGuard],
  },
  {
    path: "report/non/completed/orders/gm",
    component: NonCompletedOrdersReportComponent,
    canActivate: [GeneralManagerGuard],
  },

  {
    path: "report/item/check/s",
    component: ItemCheckReportComponent,
    canActivate: [StockGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],

  exports: [RouterModule],
})
export class AppRoutingModule {}
